import { BKJAddressInputDataProvider } from './BKJAddressInput.context.js';
export const BKJAddressInput = BKJAddressInputDataProvider;
//# sourceMappingURL=BKJAddressInput.js.map